@if (mode === 'workspace') {
<div class="workspace-tpl clearfix">
  <!-- <div *ngIf="workspaceData?.isEnable" class="list-class"
    (click)="emitAction('back')" [attr.title]="workspaceData?.backMessage || 'Back'">
    <i class="fa fa-arrow-left"></i>
  </div> -->
  @if (workspaceData?.showFilterToggle) {
<div class="list-class"
    (click)="emitAction('toggle-filters')" title="Toggle filters">
    <i class="fa fa-filter"></i>
  </div>
}
  <div class="ui-tabs-scrollable" [ngClass]="{'show-drop-down': !hideDropDown}">
    @if (!hideButtons) {
<button type="button"
      [disabled]="disableLeft"
      class="btn nav-button left-nav-button"
      (mousedown)="scrollButtonDown('left', $event)"
      (mouseup)="scrollButtonUp()"
      (mouseleave)="scrollButtonUp()">
    </button>
}
    <div class="spacer" [ngClass]="{'hidden-buttons': hideButtons}">
      <div>
        <ul class="nav-tabs" #tabContainer>
          @for (workspace of workspaces; track $index) {
<li
            [class.active]="workspace.active"
            (click)="onTabClick(workspace)">
            <div class="cont-wrapper">
              @if (workspace.filter_inherit === 1) {
<i class="fa fa-link"></i>
}
              {{ workspace.label }}
              <i
                class="fa fa-circle workspace-cache-icon"
                [ngClass]="{ cached: workspace.cachedData, loading_data: workspace.loading_data }"
                [style.color]="workspace.cachedData || workspace.loading_data ? '#e37902' : null"
                [attr.title]="cacheStatusTitle(workspace.cachedData)"
                (click)="emitAction('clear-cache', { screen_key: workspace.screen_key, link: workspace.link }); $event.stopPropagation()"></i>
            </div>
          </li>
}
        </ul>
      </div>
    </div>
    @if (!hideButtons) {
<button type="button"
      [disabled]="disableRight"
      class="btn nav-button right-nav-button"
      (mousedown)="scrollButtonDown('right', $event)"
      (mouseup)="scrollButtonUp()"
      (mouseleave)="scrollButtonUp()">
    </button>
}
    @if (!hideDropDown) {
<div class="btn-group dropdown">
      <button type="button" class="btn dropdown-toggle" #dropdownToggleBtn (click)="toggleDropdown($event)"></button>
    </div>
}
  </div>
</div>
}

@if (showDropdownMenu) {
<ul class="workspace-overflow-menu" [ngStyle]="dropdownMenuStyle" role="menu" (click)="$event.stopPropagation()">
  @for (tab of dropdownTabs; track $index) {
<li
    [class.active]="tab.active"
    role="menuitem"
    (click)="onDropdownTabClick(tab)">
    <a>{{ tab.label }}</a>
  </li>
}
</ul>
}

@if (mode === 'memory') {
<ul class="gt-tab-container" role="list">
  <li class="menu" role="listitem">
    <div class="btn-group">
      <div (click)="emitAction('toggle-nav')" role="button" tabindex="0">
        <i class="fa fa-bars"></i>
      </div>
    </div>
  </li>
  <li class="menu" role="listitem">Memory Usage</li>
</ul>
}

@if (mode === 'screen-drop') {
<div>
  <div class="modal-header">
    <h3 class="modal-title">
      {{ workspaceData?.title || 'Show / Hide Screens' }}
      <i (click)="emitAction('cancel')" class="fa fa-times pull-right"></i>
      <i
        class="fa pull-right"
        [ngClass]="{ 'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise }"
        style="margin-right: 10px; cursor: pointer;"
        (click)="minimise = !minimise"></i>
    </h3>
  </div>
  <div class="modal-body" [hidden]="minimise">
    @if (workspaceData?.loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
}
    <form class="form-inline">
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-addon"><i class="fa fa-search"></i></div>
          <input type="text" class="form-control input-sm" [ngModel]="searchText" (ngModelChange)="searchText = $event; emitAction('set-filter', { filterText: $event })" placeholder="Search Screens" />
          <div (click)="searchText=''; emitAction('clear-search')" class="input-group-addon">
            @if (searchText) {
<i class="fa fa-times"></i>
}
          </div>
        </div>
      </div>
    </form>

    @for (screen of filteredScreens; track $index) {
<div class="pull-left screen-display-menu" style="margin:10px 10px 0 0" [ngClass]="{ 'opacity-7': !screen.show_tab }">
      <div class="btn-group">
        @if (screen.show_tab) {
<div class="btn btn-sm btn-danger" (click)="emitAction('hide-screen', { screen_key: screen.screen_key })">
          <i class="fa fa-times"></i>
        </div>
}
        @if (!screen.show_tab) {
<div class="btn btn-sm btn-info" (click)="emitAction('show-screen', { screen_key: screen.screen_key })">
          <i class="fa fa-plus"></i>
        </div>
}
        <div class="btn btn-sm btn-default" (click)="emitAction('show-screen', { screen_key: screen.screen_key })">
          {{ screen.label }}
        </div>
        <div class="btn btn-sm btn-default">
          <i
            class="fa fa-circle workspace-cache-icon"
            [ngClass]="{ cached: screen.cachedData, loading_data: screen.loading_data }"
            [attr.title]="screenDropCacheTitle(screen)"></i>
        </div>
      </div>
    </div>
}

    <div class="clearfix"></div>
  </div>
  <div class="modal-footer workspace-screen-drop-footer" [hidden]="minimise">
    <button type="button" class="workspace-footer-btn workspace-footer-btn--primary" (click)="emitAction('show-all')">Show All</button>
    <button type="button" class="workspace-footer-btn workspace-footer-btn--primary" (click)="emitAction('hide-all')">Hide All</button>
  </div>
</div>
}

